import { useEffect, useState } from 'react';
import { useApolloClient } from 'react-apollo';
import { getGoogleCalendarSyncStatus } from '@kiper/account-graphql/google-calendar/query';
import {
  SYNC_API_STATUS,
  SYNC_POLL_INTERVAL_MS,
  SYNC_STATUS,
} from '../constants';

const statusByApiStatus = {
  [SYNC_API_STATUS.ready]: SYNC_STATUS.ready,
  [SYNC_API_STATUS.pending]: SYNC_STATUS.pending,
  [SYNC_API_STATUS.failed]: SYNC_STATUS.failed,
  [SYNC_API_STATUS.expired]: SYNC_STATUS.untracked,
};

const finalStatuses = [
  SYNC_STATUS.ready,
  SYNC_STATUS.failed,
  SYNC_STATUS.untracked,
];

const fetchStatus = async ({ client, session }) => {
  try {
    const { data } = await client.query({
      query: getGoogleCalendarSyncStatus,
      variables: { session },
      fetchPolicy: 'network-only',
    });
    const apiStatus =
      data &&
      data.getGoogleCalendarSyncStatus &&
      data.getGoogleCalendarSyncStatus.status;

    return statusByApiStatus[apiStatus] || SYNC_STATUS.pending;
  } catch (error) {
    return SYNC_STATUS.pending;
  }
};

const useSyncStatusPolling = ({ session }) => {
  const client = useApolloClient();
  const [status, setStatus] = useState(
    session ? SYNC_STATUS.checking : SYNC_STATUS.untracked,
  );

  useEffect(() => {
    if (!session) {
      setStatus(SYNC_STATUS.untracked);
      return undefined;
    }

    let active = true;
    let timerId = null;

    const check = async () => {
      const nextStatus = await fetchStatus({ client, session });
      if (!active) return;

      setStatus(nextStatus);

      if (!finalStatuses.includes(nextStatus)) {
        timerId = setTimeout(check, SYNC_POLL_INTERVAL_MS);
      }
    };

    check();

    return () => {
      active = false;
      clearTimeout(timerId);
    };
  }, [client, session]);

  return { status };
};

export default useSyncStatusPolling;
